import i18n from 'live/services/i18n'

import { BlocksHtml } from '../../../../common/types/api/page'

export function addHtml(id: number): BlocksHtml {
    return {
        id,
        template: `<div style="text-align:center"><h1><strong style="line-height:16px">Report Example</strong></h1></div><div style="text-align:center">${i18n(
            'A expressão Lorem ipsum em design gráfico e editoração é um texto padrão em latim utilizado na produção gráfica para preencher os espaços de texto em publicações para testar e ajustar aspectos visuais antes de utilizar conteúdo real.'
        )}</div>`
    }
}
